import API from "./apiv2";
const Service = { 
    log:(module,log)=> {
        let tmpObject = {};
        tmpObject.module = module;
        tmpObject.log = log;
        return new Promise((resolve, reject) => {
            API.post('log',null,tmpObject).then(
                result => {
                     resolve(result)
                },
                error => {
                    reject(error);
                }
            );
        });
    }
}
export default Service;